import FieldsInput from "../../../../components/FieldComponents/FieldsInput";
import { mergeClasses } from "@fluentui/react-components";
import Style from "../../../Client/ClientManagement/AddClient.style";
import { Stack } from "@fluentui/react";
import { useTranslation } from "react-i18next";

const SystemUserLastName = (props) => {
  const { systemUserLastName } = props;
  const style = Style();
  const { t } = useTranslation();
  return (
    <>
      <Stack className={style.client_field}>
        <FieldsInput
          label={t("last_name")}
          validationMessage={props.errors?.systemUserLastName?.message}
          id="systemUserLastName"
          maxLength="30"
          placeholder={t("enter_last_name")}
          name="systemUserLastName"
          inputDefaultValue={systemUserLastName}
          inputClassName={mergeClasses(style.textboxInput)}
          validation={props.register("systemUserLastName", {
            required: `${t("validation_message.last_name_is_required")}`,
          })}
        />
      </Stack>
    </>
  );
};

export default SystemUserLastName;
